import React from 'react';
import ContentBox from '@root/components/v2/content/ContentBox';
import Text from '@root/components/v2/ui-elements/Text';
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { STATUS_COLORS, UI_COLORS } from '@root/utilities/pastelColors';

const formatNumber = value => Number(value ?? 0).toLocaleString();

// Distinct list-row layout (icon chip + label/caption on the left, signed value on the right),
// intentionally different from the column/bar layout of the Severity Breakdown card above it.
const ChangeSinceLastScanCard = ({ change }) => {
  const rows = [
    {
      key: 'new',
      icon: ArrowUpRight,
      color: STATUS_COLORS.error,
      label: 'New findings',
      caption: 'Detected since the previous scan',
      value: `+${formatNumber(change?.new_findings)}`,
    },
    {
      key: 'remediated',
      icon: ArrowDownRight,
      color: STATUS_COLORS.success,
      label: 'Remediated',
      caption: 'Resolved since the previous scan',
      value: `−${formatNumber(change?.remediated)}`,
    },
    {
      key: 'active',
      icon: Minus,
      color: UI_COLORS.text.secondary,
      label: 'Still active',
      caption: 'Carried over and unresolved',
      value: formatNumber(change?.still_active),
    },
  ];

  return (
    <ContentBox
      title="Change Since Last Scan"
      paddingMode="content"
      style={{ backgroundColor: UI_COLORS.background.primary }}>
      <div className="flex flex-col px-4">
        {rows.map((row, idx) => {
          const Icon = row.icon;
          return (
            <div
              key={row.key}
              className="flex items-center justify-between py-3"
              style={{ borderBottom: idx === rows.length - 1 ? 'none' : `1px solid ${UI_COLORS.border.primary}` }}>
              <div className="flex items-center gap-3">
                <span
                  className="flex items-center justify-center rounded-lg"
                  style={{ width: 36, height: 36, backgroundColor: `${row.color}1A`, color: row.color }}>
                  <Icon size={18} strokeWidth={2.5} />
                </span>
                <div className="flex flex-col">
                  <Text className="text-[14px]" font="bold" style={{ color: UI_COLORS.text.primary }}>
                    {row.label}
                  </Text>
                  <Text className="text-[12px]" font="medium" style={{ color: UI_COLORS.text.secondary }}>
                    {row.caption}
                  </Text>
                </div>
              </div>
              <Text className="text-[20px] leading-none" font="bold" style={{ color: row.color }}>
                {row.value}
              </Text>
            </div>
          );
        })}
      </div>
    </ContentBox>
  );
};

export default ChangeSinceLastScanCard;
